import { makeStyles, useTheme } from "@material-ui/core/styles";

const drawerWidth = 240;
const borderColor = "#dee5ef";


export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",

    fontFamily: "Lato",
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0.4em",
      height: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: borderColor,
    },
  },
  paperContainer: {
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.paper,
      borderRadius: "5px",
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-elevation1": {
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-rounded": {
      borderRadius: "5px",
      border: "1px solid #dee5ef",
    },
    width: '100%',
    marginBottom: '8px'
  },
  messageRecContainer: {
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.paper,
      borderRadius: "5px",
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-elevation1": {
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-rounded": {
      borderRadius: "5px",
      border: "1px solid #dee5ef",
    },
    width: '100%',
    marginBottom: '8px'
  },
  messageSentContainer: {
    "& .MuiPaper-root": {
      backgroundColor: "#f7f9fb",
      borderRadius: "5px",
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-elevation1": {
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-rounded": {
      borderRadius: "5px",
      border: "1px solid #dee5ef",
    },
    width: '100%',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: "flex-end"
  },
  paperContent: {
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.paper,
      borderRadius: "5px",
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-elevation1": {
      boxShadow: "none",
      border: "1px solid #dee5ef",
    },
    "& .MuiPaper-rounded": {
      borderRadius: "5px",
      border: "1px solid #dee5ef",
    },
  },

  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  nestedDrawer: {
    paddingLeft: theme.spacing(4),
  },
  bottomNavDesktop: {
    width: "100%",
    maxWidth: "100vw",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  },
  bottomNavMobile:{
    position: "fixed",
    bottom: "0px",
    left: "0px",
    overflowY: "scroll",
    right: "0px",
    width: "100%",
    maxWidth: "100vw",
    height: "80px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  drawerDrawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBarTabs: {
    backgroundColor: theme.palette.background.default,
    boxShadow: "none",
    width: "100%",
    display: "flex",
  },
  appBarDrawer: {
    backgroundColor: theme.palette.background.default,
    boxShadow: "none",
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButtonDrawer: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbarDrawer: {
    minHeight: "64px",
  },
  drawerPaperDrawer: {
    width: drawerWidth,
    border: "none",
    backgroundColor: theme.palette.background.default,
  },
  listItemIconDrawer: {
    color: "#000",
    height: "0.875rem",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
  },
  listItemIconDrawerSelected: {
    color: "#000",
    height: "0.875rem",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
  },
  contentDrawer: {
    width: "100%",
    height: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: "40vw",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "40vw",
    backgroundColor: theme.palette.background.default,
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  stepFrames: {
    width: "100%",
    step: {
      "& $completed": {
        color: theme.palette.secondary.light,
      },
      "& $active": {
        color: theme.palette.secondary.dark,
      },
      "& $disabled": {
        color: theme.palette.primary.light,
      },
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  primary: {},
  step: {
    "& $completed": {
      color: theme.palette.secondary.light,
    },
    "& $active": {
      color: theme.palette.secondary.dark,
    },
    "& $disabled": {
      color: theme.palette.primary.light,
    },
  },
  paperCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%",
    width: "100%",
    marginBottom: "3vw",
  },
  grid: {},
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  stretchTextField: {
    width: '100%',
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export const getModalStyle = () => {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
};
